import {
  DispatchTrackingConfidence,
  DispatchTrackingDestination,
  DispatchTrackingPerformer,
  DispatchTrackingRoute,
} from "@ots-frontend/ots-data";

/** The parts of a dispatch or dispatch request tracking result the panel reads. */
export type DriverTracking = {
  status?: string;
  performer?: DispatchTrackingPerformer;
  destination?: DispatchTrackingDestination;
  route?: DispatchTrackingRoute;
  confidence?: DispatchTrackingConfidence;
  message?: string;
};

export const humanizeTrackingCode = (value?: string): string | undefined => value
  ?.toLowerCase()
  .replace(/_/g, " ")
  .replace(/\b\w/g, (character) => character.toUpperCase());
